export default __webpack_public_path__ + "static/media/social-tiktok.f7a906ef.svg";